document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const tab = event.target.closest(
    '[data-id="double-product-list"] .section-resource-list__collection-link[aria-current="false"]'
  );

  if (!tab) return;

  const section = tab.closest('[data-id="double-product-list"]');
  const target = tab.dataset.resourceListTab;

  if (!section || !target) return;

  section
    .querySelectorAll('[data-resource-list-tab]')
    .forEach((item) => item.setAttribute('aria-current', String(item.dataset.resourceListTab === target)));
  section
    .querySelectorAll('[data-resource-list-panel]')
    .forEach((item) => item.setAttribute('aria-current', String(item.dataset.resourceListPanel === target)));
});
